module.exports = __webpack_public_path__ + "static/img/A (16).a291753b.png";